import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@masar/env/environment';
import { Result } from 'mnm-webapp';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface ProjectModuleAccess {
    canAccess: boolean;
    canRead: boolean;
}

@Injectable({ providedIn: 'root' })
export class ProjectAccessService {
    public constructor(private readonly httpClient: HttpClient) {}

    public getAccess(): Observable<ProjectModuleAccess> {
        return this.httpClient
            .get<Result<ProjectModuleAccess>>(
                `${environment.apiUrl}/project/access`
            )
            .pipe(map(result => result.extra));
    }
}
